package com.mencanhealth.admin.data

import com.mencanhealth.admin.model.ChatMessage
import com.mencanhealth.admin.model.ChatSummary
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.Direction
import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import kotlinx.datetime.Clock

class AdminChatService {

    private val firestore = Firebase.firestore

    data class ChatPage(
        val chats: List<ChatSummary>,
        val lastDocument: DocumentSnapshot?,
        val hasMore: Boolean
    )

    suspend fun listChatsPaginated(
        pageSize: Int = 20,
        afterDocument: DocumentSnapshot? = null
    ): ChatPage {
        var query = firestore.collection("chats")
            .orderBy("lastTimestamp", Direction.DESCENDING)
            .limit(pageSize)

        if (afterDocument != null) {
            query = query.startAfter(afterDocument)
        }

        val snapshot = query.get()
        val chats = snapshot.documents.mapNotNull { doc ->
            try {
                ChatSummary(
                    userId = doc.id,
                    userName = try { doc.get<String>("userName") } catch (_: Exception) { doc.id },
                    lastMessage = try { doc.get<String>("lastMessage") } catch (_: Exception) { "" },
                    lastTimestamp = try { doc.get<Long>("lastTimestamp") } catch (_: Exception) { 0L }
                )
            } catch (_: Exception) { null }
        }

        return ChatPage(
            chats = chats,
            lastDocument = snapshot.documents.lastOrNull(),
            hasMore = snapshot.documents.size == pageSize
        )
    }

    fun observeMessages(userId: String): Flow<List<ChatMessage>> {
        return firestore.collection("chats")
            .document(userId)
            .collection("messages")
            .orderBy("timestamp", Direction.ASCENDING)
            .snapshots
            .map { snapshot ->
                snapshot.documents.map { doc ->
                    ChatMessage(
                        id = doc.id,
                        sender = doc.get<String>("sender"),
                        text = doc.get<String>("text"),
                        timestamp = doc.get<Long>("timestamp"),
                        read = doc.get<Boolean>("read")
                    )
                }
            }
    }

    suspend fun sendReply(userId: String, text: String) {
        val now = Clock.System.now().toEpochMilliseconds()
        firestore.collection("chats")
            .document(userId)
            .collection("messages")
            .add(mapOf(
                "sender" to "nutritionist",
                "text" to text,
                "timestamp" to now,
                "read" to false
            ))
        firestore.collection("chats")
            .document(userId)
            .set(mapOf(
                "lastMessage" to text,
                "lastTimestamp" to now
            ), merge = true)
    }

    suspend fun markAsRead(userId: String, messageId: String) {
        firestore.collection("chats")
            .document(userId)
            .collection("messages")
            .document(messageId)
            .update("read" to true)
    }
}
